import {
  GET_DASHBOARD_DATA_SUCCESS, DELETE_ACTIVITY_COMMENT_SUCCESS, SAVE_ACTIVITY_COMMENT_SUCCESS,
  GET_LIST_CONTACT_PERSON_DATA_SUCCESS, GET_LIST_CONTACT_COMPANY_DATA_SUCCESS, LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS,
} from '../../constants/system/actions';

const dashboardReducer: Reducer = (
  state: ReducerState = {
    dashboardData: null,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        dashboardData: action.data,
      };
    case DELETE_ACTIVITY_COMMENT_SUCCESS:
    case SAVE_ACTIVITY_COMMENT_SUCCESS:
      if (!state.dashboardData) {
        return state;
      }

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          recentlyUpdatedDealsData: state.dashboardData.recentlyUpdatedDealsData.map((dealItem: Deal): Deal => ({
            ...dealItem,
            newDealActivity: (
              dealItem.newDealActivity && dealItem.newDealActivity.id === action.data.activityId
              && action.data.updatedData ? ({
                ...dealItem.newDealActivity,
                updatedDate: action.data.updatedData.updatedDate,
                updatedDateText: action.data.updatedData.updatedDateText,
                updatedByUserText: action.data.updatedData.updatedByUserText,
                comments: action.data.comments,
                attachments: action.data.attachments,
              }) : dealItem.newDealActivity
            ),
          })),
        },
      };
    case GET_LIST_CONTACT_PERSON_DATA_SUCCESS:
      if (!state.dashboardData) {
        return state;
      }

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          contactPersonList: action.data,
        },
      };
    case GET_LIST_CONTACT_COMPANY_DATA_SUCCESS:
      if (!state.dashboardData) {
        return state;
      }

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          contactCompanyList: action.data,
        },
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        dashboardData: null,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
